"use client";
import React, { Suspense } from "react";
import AlgoliaSearchProvider from "../algolia/SearchProvider";
import { algoliaConfig } from "@/services/algolia/config";
import SearchTabs from "./_components/Search/SearchTabs";

export default function SearchResults() {
  return (
    <AlgoliaSearchProvider
      indexName={algoliaConfig.indexNames.productQuerySuggestion}
      insights={true}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <SearchTabs />
      </Suspense>
    </AlgoliaSearchProvider>
  );
}
